import React from 'react';
import { View, Text, TextInput } from 'react-native';
import theme from '../../theme';

export default function FormField({ label, value, onChangeText, placeholder, error, keyboardType, autoCapitalize }) {
  return (
    <View style={{ marginBottom: 16 }}>
      <Text style={{
        fontFamily: theme.typography.fontMono,
        fontSize: theme.typography.size['2xs'],
        letterSpacing: theme.trackingPx(theme.typography.size['2xs'], 'wide'),
        textTransform: 'uppercase',
        color: theme.colors.textTertiary,
        marginBottom: 6,
      }}>
        {label}
      </Text>
      <TextInput
        value={value}
        onChangeText={onChangeText}
        placeholder={placeholder}
        placeholderTextColor={theme.colors.textDisabled}
        keyboardType={keyboardType}
        autoCapitalize={autoCapitalize}
        style={{
          fontFamily: theme.typography.fontSans,
          fontSize: theme.typography.size.base,
          color: theme.colors.textPrimary,
          borderWidth: theme.borderWidth.thin,
          borderColor: error ? theme.colors.statusNegative : theme.colors.borderDefault,
          borderRadius: theme.radii.md,
          paddingHorizontal: 12,
          paddingVertical: 10,
        }}
      />
      {error ? (
        <Text style={{ fontFamily: theme.typography.fontSans, fontSize: theme.typography.size['2xs'], color: theme.colors.statusNegative, marginTop: 4 }}>
          {error}
        </Text>
      ) : null}
    </View>
  );
}